// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-object-buttons[data-v-f00b4906]{padding:10px 35px 10px 20px;position:relative;background:#f2f7fe;min-height:50px;border-bottom:1px solid #d9dadb}.edit-object-buttons a[data-v-f00b4906]{width:100%;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
